export default {
  master_title: 'Brändi-tila - Ruokalista',
  title: 'Ruokalista',
  form: {
    has_internal_product_numbers: {
      label: 'Määritä tuotenumerot',
      tooltip:
        'Määritä tuotteille automaattisesti numerot niiden sijainnin perusteella ruokalistalla. Numero tulostetaan kuitteihin',
    },
  },
  buttons: {
    new_menu: 'Uusi ruokalista',
    export_menu: 'Vie ruokalista',
    refresh: 'Päivitä',
  },
  modals: {
    delete_category: {
      title: 'Poista {{name}}',
    },
    delete_products: {
      title: 'Poistetaanko {{count}} tuotetta?',
      description: '<strong>{{count}}</strong> poistetaan ruokalistalta',
    },
  },
  toasts: {
    failed_to_load_data: 'Tietojen lataaminen epäonnistui',
    failed_to_delete_menu: 'Ruokalistan poistaminen epäonnistui, yritä uudelleen',
    menu_got_deleted: 'Ruokalista poistettu',
    failed_to_delete_category: 'Kategorian poistaminen epäonnistui, yritä uudelleen',
    category_got_deleted: 'Kategoria poistettu',
    failed_to_delete_products: 'Tuotteiden poistaminen epäonnistui, yritä uudelleen',
    product_got_deleted_one: 'Tuote poistettu',
    product_got_deleted_other: 'Tuotteet poistettu',
    failed_to_generate_product_number: 'Jokin meni pieleen. Lataa sivu uudelleen ja yritä uudelleen',
    menu_exported: 'Ruokalista on viety',
    failed_to_export_menu: 'Ruokalistan vieminen epäonnistui',
  },
};
